module.exports = __webpack_public_path__ + "static/media/navBar-logo.8955930d.svg";